let translateStatic = {
	heroTitle: 'Találd meg biztonsággal otthonod!'
};

export default translateStatic;
